export default "__VITE_ASSET__DveFWrEf__"